export default "__VITE_ASSET__C3s5S_Lg__"